import { ZIcon, ZPopover, ZTypography } from "@atoms";
import { EColors } from "@atoms/ZColors/interface";
import { EIcons, ETwoToneIcons } from "@atoms/ZIcon/interface";
import React, { useState } from "react";
import "./index.less";
import { SellPriceRoundingOptionProps } from "@molecules/ConfigSellPriceRoundingOption/interface";
import ConfigSellPriceRoundingOption from "@molecules/ConfigSellPriceRoundingOption";

const { ZText } = ZTypography;

const SellPriceRoundingOption: React.FC<
	SellPriceRoundingOptionProps
> = props => {
	const [isVisible, setIsVisible] = useState<boolean>(false);
	return (
		<ZPopover
			content={
				<ConfigSellPriceRoundingOption
					{...props}
					handleClose={() => setIsVisible(false)}
				/>
			}
			destroyTooltipOnHide={true}
			placement="bottomLeft"
			trigger="click"
			visible={isVisible}
			onVisibleChange={visible => setIsVisible(visible)}
			overlayClassName="rounding-options-container"
		>
			<div className="flex items-center ml-auto cursor-pointer">
				<ZIcon
					name={
						props.roundingDetails?.is_enabled
							? ETwoToneIcons.SLIDERHORIZONTALACTIVE
							: EIcons.SLIDERHORIZONTAL
					}
					color={EColors.BLUE}
					colorVariant={6}
					size="sm"
					className={props.roundingDetails?.is_enabled ? "" : "mt-1"}
					isTwoToneIcon={!!props.roundingDetails?.is_enabled}
				/>
				<ZText
					className="ml-2"
					color={EColors.BLUE}
					colorVariant={6}
					data-testid="apply-rounding"
				>
					Apply rounding
				</ZText>
			</div>
		</ZPopover>
	);
};

export default SellPriceRoundingOption;
